import { Autocomplete, Chip, TextField } from "@mui/material";
import { filter } from "lodash";
import React from "react";

import LotAPI from "../api/Lot.api";
import { Lot, Ranch } from "../types";

type LotOption = { label: string; value: Lot };

export default function LotMultiSelectSearch({
  lots,
  setLots,
  ranch,
}: {
  lots: Lot[];
  setLots: (lots: Lot[]) => void;
  ranch: Ranch;
}) {
  const [query, setQuery] = React.useState<string>("");
  const { data } = LotAPI.useSearchByRanch({ query, ranch });

  const options = data ? data.map((o) => ({ label: o.num, value: o })) : [];

  return (
    <Autocomplete
      freeSolo
      multiple
      autoHighlight
      filterSelectedOptions
      id="loet-search-multi-select-outlined"
      options={options}
      filterOptions={(options, params) => {
        const selectedLotIds = lots.map((lot) => lot.id);
        const filtered = filter(
          options,
          (option: LotOption) => !selectedLotIds.includes(option.value.id),
        );
        return filtered;
      }}
      renderTags={(value: readonly LotOption[], getTagProps) =>
        value.map((option: LotOption, index: number) => (
          <Chip
            variant="outlined"
            label={option.label}
            {...getTagProps({ index })}
          />
        ))
      }
      onChange={(event: any, newValues: (LotOption | string)[]) => {
        const lotOptions = filter(
          newValues,
          (obj: LotOption | string) => typeof obj !== "string",
        ) as LotOption[];
        setLots(lotOptions.map((obj) => obj.value));
      }}
      value={lots.map((lot) => ({
        label: lot.num,
        value: lot,
      }))}
      onInputChange={(event, newQuery) => {
        setQuery(newQuery);
      }}
      disableCloseOnSelect
      style={{ width: "100%" }}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          label="Lots"
          placeholder="Filter by lots"
        />
      )}
    />
  );
}
